import React from 'react'

import './litters-current.css'

const LittersCurrent = (props) => {
  return (
    <section className="litters-current-thq-litters-current-elm litters-current">
      <div className="litters-container">
        <header className="litters-header">
          <h2 className="section-title">Current Litters</h2>
          <p className="section-subtitle">
            Discover our newest additions at Sycorax Cats, all GCCF registered
            and raised with love...and sometimes a bit of chaos.
          </p>
        </header>
        <span className="litters-current-text10">NO KITTENS CURRENTLY :( </span>
        <div className="litters-grid" style={{ display: 'none' }}>
          <article className="kitten-card">
            <div className="kitten-image-wrapper">
              <img
                alt="British Shorthair kitten in basket"
                src="https://images.pexels.com/photos/10611247/pexels-photo-10611247.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                className="kitten-img"
              />
              <div className="kitten-status-badge">
                <span>Available</span>
              </div>
            </div>
            <div className="kitten-details">
              <h3 className="kitten-name">Luna</h3>
              <div className="litters-current-thq-kitten-meta-elm1 kitten-meta"></div>
              <p className="section-content">
                A sweet-natured girl with a dense plush coat and striking copper
                eyes in the making.
              </p>
            </div>
          </article>
          <article className="kitten-card">
            <div className="kitten-image-wrapper">
              <img
                alt="Grey British Shorthair kitten"
                src="https://images.pexels.com/photos/34806509/pexels-photo-34806509.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                className="kitten-img"
              />
              <div className="kitten-status-badge">
                <span>Reserved</span>
              </div>
            </div>
            <div className="kitten-details">
              <h3 className="kitten-name">Oliver</h3>
              <div className="litters-current-thq-kitten-meta-elm2 kitten-meta"></div>
              <p className="section-content">
                The largest of the litter, Oliver is a playful boy who loves his
                climbing frame.
              </p>
            </div>
          </article>
          <article className="kitten-card">
            <div className="kitten-image-wrapper">
              <img
                alt="Kitten with yellow bow"
                src="https://images.pexels.com/photos/10611243/pexels-photo-10611243.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                className="kitten-img"
              />
              <div className="kitten-status-badge">
                <span>Available</span>
              </div>
            </div>
            <div className="kitten-details">
              <h3 className="kitten-name">Milo</h3>
              <div className="litters-current-thq-kitten-meta-elm3 kitten-meta"></div>
              <p className="section-content">
                Milo is the explorer of the group, always the first to
                investigate something new.
              </p>
            </div>
          </article>
          <article className="litters-current-thq-kitten-card-elm4 kitten-card">
            <div className="kitten-image-wrapper">
              <img
                alt="Kitten with flowers"
                src="https://images.pexels.com/photos/10611252/pexels-photo-10611252.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                className="kitten-img"
              />
              <div className="kitten-status-badge">
                <span>Available</span>
              </div>
            </div>
            <div className="kitten-details">
              <h3 className="kitten-name">Bella</h3>
              <div className="kitten-meta">
                <div className="meta-item">
                  <svg
                    fill="none"
                    width="20"
                    xmlns="http://www.w3.org/2000/svg"
                    height="20"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect x="3" y="4" rx="2" width="18" height="18"></rect>
                    <path d="M8 2v4m8-4v4M3 10h18"></path>
                  </svg>
                  <span>Born: May 12, 2024</span>
                </div>
                <div className="meta-item">
                  <svg
                    fill="none"
                    width="20"
                    xmlns="http://www.w3.org/2000/svg"
                    height="20"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M12 5c.67 0 1.35.09 2 .26c1.78-2 5.03-2.84 6.42-2.26c1.4.58-.42 7-.42 7c.57 1.07 1 2.24 1 3.44C21 17.9 16.97 21 12 21s-9-3-9-7.56c0-1.25.5-2.4 1-3.44c0 0-1.89-6.42-.5-7s4.72.23 6.5 2.23A9 9 0 0 1 12 5m-4 9v.5m8-.5v.5"></path>
                    <path d="M11.25 16.25h1.5L12 17z"></path>
                  </svg>
                  <span>Blue Self British Shorthair</span>
                </div>
              </div>
              <p className="section-content">
                A dainty little girl who loves to snuggle after a long session
                of chasing toys.
              </p>
            </div>
          </article>
          <article className="litters-current-thq-kitten-card-elm5 kitten-card">
            <div className="kitten-image-wrapper">
              <img
                alt="Fluffy kitten portrait"
                src="https://images.pexels.com/photos/14492412/pexels-photo-14492412.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                className="kitten-img"
              />
              <div className="kitten-status-badge">
                <span>Reserved</span>
              </div>
            </div>
            <div className="kitten-details">
              <h3 className="kitten-name">Jasper</h3>
              <div className="kitten-meta">
                <div className="meta-item">
                  <svg
                    fill="none"
                    width="20"
                    xmlns="http://www.w3.org/2000/svg"
                    height="20"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect x="3" y="4" rx="2" width="18" height="18"></rect>
                    <path d="M8 2v4m8-4v4M3 10h18"></path>
                  </svg>
                  <span>Born: May 12, 2024</span>
                </div>
                <div className="meta-item">
                  <svg
                    fill="none"
                    width="20"
                    xmlns="http://www.w3.org/2000/svg"
                    height="20"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M12 5c.67 0 1.35.09 2 .26c1.78-2 5.03-2.84 6.42-2.26c1.4.58-.42 7-.42 7c.57 1.07 1 2.24 1 3.44C21 17.9 16.97 21 12 21s-9-3-9-7.56c0-1.25.5-2.4 1-3.44c0 0-1.89-6.42-.5-7s4.72.23 6.5 2.23A9 9 0 0 1 12 5m-4 9v.5m8-.5v.5"></path>
                    <path d="M11.25 16.25h1.5L12 17z"></path>
                  </svg>
                  <span>Blue Self British Shorthair</span>
                </div>
              </div>
              <p className="section-content">
                Jasper is a gentle soul with a very calm temperament, perfect
                for a quiet home.
              </p>
            </div>
          </article>
          <article className="litters-current-thq-kitten-card-elm6 kitten-card">
            <div className="kitten-image-wrapper">
              <img
                alt="Kitten licking paw"
                src="https://images.pexels.com/photos/60635/cat-animals-kitten-kitty-60635.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                className="kitten-img"
              />
              <div className="kitten-status-badge">
                <span>Available</span>
              </div>
            </div>
            <div className="kitten-details">
              <h3 className="kitten-name">Sophie</h3>
              <div className="kitten-meta">
                <div className="meta-item">
                  <svg
                    fill="none"
                    width="20"
                    xmlns="http://www.w3.org/2000/svg"
                    height="20"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect x="3" y="4" rx="2" width="18" height="18"></rect>
                    <path d="M8 2v4m8-4v4M3 10h18"></path>
                  </svg>
                  <span>Born: May 12, 2024</span>
                </div>
                <div className="meta-item">
                  <svg
                    fill="none"
                    width="20"
                    xmlns="http://www.w3.org/2000/svg"
                    height="20"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M12 5c.67 0 1.35.09 2 .26c1.78-2 5.03-2.84 6.42-2.26c1.4.58-.42 7-.42 7c.57 1.07 1 2.24 1 3.44C21 17.9 16.97 21 12 21s-9-3-9-7.56c0-1.25.5-2.4 1-3.44c0 0-1.89-6.42-.5-7s4.72.23 6.5 2.23A9 9 0 0 1 12 5m-4 9v.5m8-.5v.5"></path>
                    <path d="M11.25 16.25h1.5L12 17z"></path>
                  </svg>
                  <span>Blue Self British Shorthair</span>
                </div>
              </div>
              <p className="section-content">
                Sophie is a little comedian, often seen chasing her own tail or
                pouncing on shadows.
              </p>
            </div>
          </article>
        </div>
      </div>
    </section>
  )
}

export default LittersCurrent
